<template>
  <section class="bank-ranking-form">
    <embed-frame
      class="bank-ranking-form-frame"
      endpoint="bank_ranking/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'BankRankingForm',
    components: {
      EmbedFrame,
    },
    computed: {
      embedSettings() {
        return {
          bank_ranking: {
            form: {
              store_id: this.$route.params.id,
            },
          },
        };
      },
      embedCallbacks() {
        return {
          'bank_ranking:update': this.callback,
        };
      },
    },
    methods: {
      callback() {
        this.$router.push({
          name: 'settings-bank-ranking-list',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .bank-ranking-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
